import { DataViewAlt24, DocumentUnknown24 } from "@carbon/icons-react";
import { Search32 } from "@carbon/icons-react";
import { Form, Loading } from "carbon-components-react";
import {
  Row,
  Column,
  TextInput,
  Button,
  DataTable,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  TableToolbarContent,
} from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Card from "../../components/Card/Card";
import TablePagination from "../../components/Pagination/Pagination";
import http from "../../http-common";

const tableHeaders = [
  {
    header: "Nome",
    key: "firstName",
  },
  {
    header: "Apelido",
    key: "lastName",
  },
  {
    header: "Telefone",
    key: "phoneNumber",
  },
  {
    header: "# candidaturas registadas",
    key: "relations",
  },
];

const LinkList = ({ url1, url2, isOpen }) => (
  <ul style={{ display: "flex" }}>
    <li className="mr-1">
      <Link to={url1} title="Consultar Candidatura">
        <DataViewAlt24 />
      </Link>
    </li>
    <li>
      <Link to={url2} title="Consultar Questionário">
        <DocumentUnknown24 />
      </Link>
    </li>
  </ul>
);

const getCellContent = (cell, id) => {
  if (cell.info.header === "actions") {
    return (
      <LinkList
        url1={"../candidature/" + id}
        url2={"../self-knowledge-questionnaire/" + id}
      />
    );
  }

  return cell.value;
};

const EnrollmentOfficerPage = () => {
  const [officers, setOfficers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const featchData = async () => {
    try {
      const response = await http.get("/users/count-candidatures-by-officer");
      getData(response);
    } catch (error) {}
  };

  const getData = (response) => {
    const data = response.data.map((o) => ({
      id: "o" + o.id,
      firstName: o.firstName,
      lastName: o.lastName,
      phoneNumber: o.username,
      relations: o.relations,
    }));
    setOfficers(data);
    setIsLoading(false);
  };

  useEffect(() => {
    featchData();
  }, []);

  return (
    <Card title="Candidaturas por Oficial de Inscrição">
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />
      <DataTable
        rows={officers}
        headers={tableHeaders}
        isSortable
        useZebraStyles
      >
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {getCellContent(cell, row.id)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
    </Card>
  );
};

export default EnrollmentOfficerPage;
